import { render, staticRenderFns } from "./BlogForm.vue?vue&type=template&id=15d8a5f0&"
import script from "./BlogForm.vue?vue&type=script&lang=js&"
export * from "./BlogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports